export const isNotNullOrUndefined = (value: unknown) => {
  return value !== null && value !== undefined
}

export const stringToBoolean = (value?: string) => {
  if (value?.toLowerCase() === 'true') return true
  if (value?.toLowerCase() === 'false') return false
  return undefined
}
